import React, { useState } from "react";

const CampaignConversionPageSimple: React.FC = () => {
  // Basic notification state
  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [toastType, setToastType] = useState<"success" | "error">("success");

  // Helper functions for notifications
  const showNotification = (
    message: string,
    type: "success" | "error" = "success"
  ) => {
    setToastMessage(message);
    setToastType(type);
    setShowToast(true);
    setTimeout(() => setShowToast(false), 3000);
  };

  return (
    <div className="h-[calc(100vh-8rem)] flex flex-col bg-gray-50 overflow-hidden -m-6">
      {/* Header */}
      <div className="bg-white border-b border-gray-200 px-4 py-4">
        <div className="flex items-center space-x-4">
          <div className="flex items-center space-x-3">
            <div className="mt-6 px-4">
              <h1 className="text-2xl font-bold text-gray-900 ">
                Chuyển đổi Chiến dịch
              </h1>
              <p className="text-sm text-gray-600">
                Quản lý và theo dõi hiệu quả chiến dịch
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Two page layout */}
      <div className="flex-1 flex overflow-hidden min-h-0">
        {/* Left Page */}
        <div className="flex-1 flex flex-col border-r border-gray-200 min-h-0">
          {/* Left Page Header */}
          <div className="px-4 py-4 border-b border-gray-200 bg-white">
            <div className="flex items-center justify-between">
              <div className="flex items-center space-x-3">
                <div className="w-8 h-8 bg-gray-100 rounded-lg flex items-center justify-center">
                  <svg
                    className="w-5 h-5 text-gray-600"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"
                    />
                  </svg>
                </div>
                <div>
                  <h2 className="text-lg font-semibold text-gray-900">
                    Thống kê Chiến dịch
                  </h2>
                  <p className="text-sm text-gray-500">
                    Thống kê và báo cáo tổng quan
                  </p>
                </div>
              </div>
              <div className="flex items-center space-x-2">
                <div className="w-2 h-2 bg-gray-400 rounded-full"></div>
                <span className="text-xs text-gray-500 font-medium">
                  Trang 1
                </span>
              </div>
            </div>
          </div>

          {/* Left Page Content */}
          <div className="flex-1 overflow-y-auto p-2 bg-gray-50">
            <div className="space-y-4">
              {/* Test content */}
              {Array.from({ length: 8 }, (_, i) => (
                <div
                  key={i}
                  className="bg-white p-4 rounded-lg border border-gray-200"
                >
                  <h3 className="text-base font-medium text-gray-900 mb-2">
                    Test Content {i + 1}
                  </h3>
                  <p className="text-sm text-gray-600 mb-3">
                    Đây là nội dung test cho trang thống kê - Item {i + 1}
                  </p>
                  <div className="p-3 bg-gray-50 rounded border">
                    <p className="text-xs text-gray-500">
                      Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Right Page */}
        <div className="flex-1 flex flex-col min-h-0">
          {/* Right Page Header */}
          <div className="px-4 py-4 border-b border-gray-200 bg-white">
            <div className="flex items-center justify-between">
              <div className="flex items-center space-x-3">
                <div className="w-8 h-8 bg-gray-100 rounded-lg flex items-center justify-center">
                  <svg
                    className="w-5 h-5 text-gray-600"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M16 8v8m-4-5v5m-4-2v2m-2 4h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"
                    />
                  </svg>
                </div>
                <div>
                  <h2 className="text-lg font-semibold text-gray-900">
                    Phân tích Chiến dịch
                  </h2>
                  <p className="text-sm text-gray-500">
                    Biểu đồ và phân tích chi tiết
                  </p>
                </div>
              </div>
              <div className="flex items-center space-x-2">
                <div className="w-2 h-2 bg-gray-400 rounded-full"></div>
                <span className="text-xs text-gray-500 font-medium">
                  Trang 2
                </span>
              </div>
            </div>
          </div>

          {/* Right Page Content */}
          <div className="flex-1 overflow-y-auto p-2 bg-gray-50">
            <div className="space-y-4">
              {/* Test content */}
              {Array.from({ length: 6 }, (_, i) => (
                <div
                  key={i}
                  className="bg-white p-4 rounded-lg border border-gray-200"
                >
                  <h3 className="text-base font-medium text-gray-900 mb-2">
                    Analysis Content {i + 1}
                  </h3>
                  <p className="text-sm text-gray-600 mb-3">
                    Đây là nội dung test cho trang phân tích - Item {i + 1}
                  </p>
                  <div className="p-3 bg-gray-50 rounded border">
                    <p className="text-xs text-gray-500">
                      Ut enim ad minim veniam, quis nostrud exercitation.
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* Toast Notification */}
      {showToast && (
        <div className="fixed top-4 right-4 z-50 animate-in slide-in-from-right duration-300">
          <div
            className={`px-4 py-3 rounded-md shadow-lg flex items-center ${
              toastType === "success"
                ? "bg-green-500 text-white"
                : "bg-red-500 text-white"
            }`}
          >
            <svg
              className="w-5 h-5 mr-2"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              {toastType === "success" ? (
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M5 13l4 4L19 7"
                />
              ) : (
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M6 18L18 6M6 6l12 12"
                />
              )}
            </svg>
            {toastMessage}
            <button
              onClick={() => setShowToast(false)}
              className="ml-2 text-white/80 hover:text-white"
            >
              <svg
                className="w-4 h-4"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default CampaignConversionPageSimple;
